import type { SearchResultHighlight } from '@responses/search';

export interface HighlightFragment {
  blockId?: string;
  blockName?: string;
  text: string;
}

/** One row per highlighted fragment, carrying the block it came from. */
export const flattenHighlights = (highlights?: SearchResultHighlight[]): HighlightFragment[] =>
  (highlights ?? []).flatMap((highlight) =>
    highlight.fragments.map((text) => ({ blockId: highlight.blockId, blockName: highlight.blockName, text })),
  );

/** The block to deep-link to when the whole result is opened: the first matched block. */
export const getFirstMatchedBlockIds = (highlights?: SearchResultHighlight[]): string[] =>
  Array.from(new Set(highlights?.map((highlight) => highlight.blockId).filter((blockId) => blockId !== undefined)));
